import { render, staticRenderFns } from "./Drilldown.vue?vue&type=template&id=3b86645c&scoped=true"
import script from "./Drilldown.vue?vue&type=script&lang=js"
export * from "./Drilldown.vue?vue&type=script&lang=js"
import style0 from "./Drilldown.vue?vue&type=style&index=0&id=3b86645c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86645c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VRow,VSlideYTransition})
